import React, { useState, useCallback, useEffect } from "react";
// import { FaTrash, FaImage, FaUpload, FaCheckCircle } from "react-icons/fa";
import "./style.css";
import {
  FaTrash,
  FaImage,
  FaUpload,
  FaCheckCircle,
  FaEye,
} from "react-icons/fa";

const ImageUploader = ({
  onImageChange,
  maxSizeMB = 5,
  label = "Upload Image",
  className = "",
  disabled = false,
  acceptedFormats = "image/*",
  maxDimensions = { width: 1920, height: 1080 },
  initialImageUrl,
  imagePreview,
  setImagePreview,
}) => {
  // const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [error, setError] = useState("");
  const [isCompressing, setIsCompressing] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // ImageUploader में
  console.log("initialImageUrlinitialImageUrl", initialImageUrl);
  useEffect(() => {
    if (initialImageUrl && !imagePreview) {
      setImagePreview(initialImageUrl);
    }
  }, [initialImageUrl]);

  // Image Compression Function (same as before)
  const compressImage = useCallback(
    (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const img = new Image();

          img.onload = () => {
            let { width, height } = img;
            const ratio = Math.min(
              maxDimensions.width / width,
              maxDimensions.height / height,
            );
            if (ratio < 1) {
              width *= ratio;
              height *= ratio;
            }

            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);

            let quality = 0.9;
            const compress = () => {
              canvas.toBlob(
                (blob) => {
                  const sizeMB = blob.size / (1024 * 1024);
                  if (sizeMB <= maxSizeMB || quality <= 0.1) {
                    resolve(new File([blob], file.name, { type: blob.type }));
                  } else {
                    quality -= 0.1;
                    compress();
                  }
                },
                file.type,
                quality,
              );
            };
            compress();
          };

          img.src = e.target.result;
        };

        reader.readAsDataURL(file);
      });
    },
    [maxSizeMB, maxDimensions],
  );

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setError("");
    setIsCompressing(true);

    try {
      if (file.size > maxSizeMB * 1024 * 1024) {
        throw new Error(`Image size must be less than ${maxSizeMB}MB`);
      }

      const compressedFile = await compressImage(file);

      if (compressedFile.size > maxSizeMB * 1024 * 1024) {
        throw new Error(
          `Compressed image (${(compressedFile.size / 1024 / 1024).toFixed(2)}MB) exceeds ${maxSizeMB}MB limit`,
        );
      }

      setImageFile(compressedFile);
      setImagePreview(URL.createObjectURL(compressedFile));
      onImageChange(compressedFile);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsCompressing(false);
    }
  };

  const removeImage = () => {
    setImageFile(null);
    setImagePreview(null);
    setError("");
    onImageChange(null);
    document.getElementById("image-upload-input").value = "";
  };

  return (
    <div className={`image-uploader-container ${className}`}>
      {imagePreview ? (
        <div className="preview-container">
          <div className="preview-image-wrapper text-center">
            <img src={imagePreview} alt="Preview" className="preview-image" />

            <div className="preview-actions">
              {!disabled && (
                <button
                  className="remove-btn"
                  onClick={removeImage}
                  title="Remove image"
                >
                  <FaTrash />
                </button>
              )}
            </div>
            <p
              type="btn"
              className="view-btn"
              onClick={() => setIsModalOpen(true)}
              // title="View full image"
            >
              {/* <FaEye />  */}
              View Full Size
            </p>
          </div>
          {isModalOpen && (
            <div
              className="modal-overlay"
              onClick={() => setIsModalOpen(false)}
            >
              <img
                src={imagePreview}
                alt="Full view"
                className="modal-image"
                onClick={(e) => e.stopPropagation()}
              />
              <button
                className="modal-close-btn"
                onClick={() => setIsModalOpen(false)}
              >
                ×
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="upload-area">
          <div style={{ display: "flex" }}>
            <div className="upload-icon">
              <FaImage size={50} />
            </div>

            <div className="upload-input-wrapper">
              <input
                id="image-upload-input"
                type="file"
                className="upload-input"
                accept={acceptedFormats}
                onChange={handleImageUpload}
                disabled={disabled || isCompressing}
              />
            </div>
            {!disabled && (
              <div>
                <p className="upload-subtitle">JPG, PNG up to {maxSizeMB}MB</p>
                <label htmlFor="image-upload-input" className="upload-btn">
                  <FaUpload />
                  <span>Choose Image</span>
                </label>
              </div>
            )}
          </div>
        </div>
      )}

      {isCompressing && (
        <div className="loading-overlay">
          <div
            className="spinner-border spinner-border-sm me-2"
            role="status"
          ></div>
          <span>Compressing image...</span>
        </div>
      )}

      {error && (
        <div className="alert alert-danger py-2 small">
          <i className="fas fa-exclamation-triangle me-1"></i>
          {error}
        </div>
      )}
    </div>
  );
};

export default ImageUploader;
